export const COUNTRY_VIEWS = {
  STATISTICS: 'statistics',
  SQUAD: 'squad',
  MATCHES: 'matches',
  CLASSIFICATION: 'classification',
};

export const COUNTRY_VIEW_LABELS = {
  [COUNTRY_VIEWS.STATISTICS]: {
    key: 'eventodeportivo_paises_tabs2_texto_tab1',
    length: 19,
  },
  [COUNTRY_VIEWS.SQUAD]: {
    key: 'eventodeportivo_paises_tabs2_texto_tab2',
    length: 19,
  },
  [COUNTRY_VIEWS.MATCHES]: {
    key: 'eventodeportivo_paises_tabs2_texto_tab3',
    length: 19,
  },
  [COUNTRY_VIEWS.CLASSIFICATION]: {
    key: 'eventodeportivo_paises_tabs2_texto_tab4',
  },
};
